import { JournalState } from '../common';

export const initialJournalState: JournalState = {
  journalCode: null,
  isNeedToLoadJournalSettings: false,
  isNeedToLoadRecords: false,
  isReadyToLoadRecords: false,
  journalColumns: [],
  displayingColumns: [],
  columnsProperties: [],
  records: [],
  searchText: '',
  hasErrors: false,
  pageSize: 1000,
  rowsLimit: 1000,
};
